import { makeStyles } from "@material-ui/core";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../../../Utils/_helpers";
import SoundsDialog from "./Utils/Popup/SoundsDialog";

const useStyles = makeStyles((theme) => ({
  disclaimer: {
    fontSize: "12px",
    display: "flex",
    alignItems: "center",
  },
  terms: {
    fontSize: "12px",
    marginLeft: 12,
  },
  highLightText: {
    color: "#892193",
    fontSize: "12px",
    cursor: "pointer",
    "&:hover": {
      color: "#892193",
    },
  },
  listHeader: {
    marginTop: "24px",
    fontSize: "16px",
    fontWeight: 500,
  },
  descList: {
    fontSize: "15px",
    fontWeight: 400,
    color: "#464e5f",
  },
}));
const SoundsDisclaimer = () => {
  const classes = useStyles();
  const [openTermsPopup, setOpenTermsPopup] = useState(false);

  const handleCloseTermsPopup = () => {
    setOpenTermsPopup(false);
  };

  return (
    <div className="ml-2 mt-10">
      <div className="d-flex flex-column">
        <div className={`my-2 ${classes.disclaimer}`}>
          <img
            alt=""
            className="img-info mt-0 "
            src={toAbsoluteUrl("/media/sr/icons/info.svg")}
          />

          <div>
            <span style={{ fontWeight: 600 }}>
              {`Disclaimer : `}
              <span style={{ fontWeight: 400 }}>
                All files being uploaded to your SuperRecpetionist account are
                subject to review by our team for objectionable content. Any
                such content will be rejected and removed from your account
              </span>
            </span>
          </div>
        </div>

        <div className={`d-flex mt-4 ${classes.terms} `}>
          <span style={{ fontWeight: 400 }}>
            {`View the `}
            <Link
              onClick={() => {
                setOpenTermsPopup(true);
              }}
              className={`${classes.highLightText} `}
              to="#"
            >
              Terms and Conditions
            </Link>

            {` agreed upon for use of SuperReceptionist and the `}

            <Link
              className={`${classes.highLightText} `}
              target="_blank"
              rel="noopener noreferrer"
              to={{ pathname: "https://www.knowlarity.com/privacy-policy" }}
            >
              Knowlarity Privacy Policy
            </Link>
          </span>
        </div>
      </div>

      <SoundsDialog
        open={openTermsPopup}
        handleClose={() => {
          handleCloseTermsPopup(false);
        }}
        maxWidth="lg"
        width="100%"
        title="Our Terms and Conditions"
      >
        <div
          className="d-flex flex-column ml-n5"
          style={{ overflowX: "hidden" }}
        >
          <p style={{ fontWeight: 500, fontSize: "14px", color: "#464e5f" }}>
            Please read and agree to the terms and conditions below before you
            continue to use the SuperReceptionist services
          </p>

          <p
            className="text-center mt-5"
            style={{ fontSize: "16px", color: "#464e5f" }}
          >
            <strong>TERMS OF USE</strong>
          </p>

          <ol className="m-0 mb-10" style={{ paddingInlineStart: 30 }}>
            <li className={`${classes.listHeader}`}>
              General
              <ul
                className={`mt-2 ${classes.descList}`}
                style={{ listStyleType: "none" }}
              >
                <li className="mb-5">
                  In terms of the Information Technology Act, 2000, this
                  document is an electronic record. Being generated by a
                  computer system it does not require any physical or digital
                  signatures.
                </li>

                <li className="mb-5">
                  This document is published in accordance with the provisions
                  of Rule 3 (1) of the Information Technology (Intermediaries
                  guidelines) Rules, 2011 that require publishing the rules and
                  regulations, privacy policy and Terms of Use for access or
                  usage of Knowlarity.
                </li>

                <li className="mb-5">
                  This Website by the URL sr.knowlarity.com is owned and
                  operated by Knowlarity Communications Private Limited (here
                  after referred to as, <strong>“Company”</strong>), a company
                  incorporated under The Companies Act, 1956 with its registered
                  and Corporate office at AWFIS, Ambience Mall, 7th Floor, Gate
                  No.-4, Ambience Island, NH8, Gurugram, Haryana, 122002 and
                  corporate office at AWFIS, Ambience Mall, 7th Floor, Gate
                  No.-4, Ambience Island, NH8, Gurugram, Haryana, 122002.
                </li>

                <li className="mb-5">
                  The expressions <strong>“We”, “Us”, “Our”, “Website”</strong>{" "}
                  shall mean Knowlarity Communications Private Limited or its
                  affiliates or agents.
                </li>

                <li className="mb-5">
                  The Company is engaged in the business of information and
                  technology services and is the owner of indigenously developed
                  software and original business methods related to virtual
                  and/or cloud communication services. The Company uses original
                  software and business methods to provide IT solutions related
                  to cloud communication products including but not limited to
                  “SuperReceptionist” and “SmartIVR”,” “Automated Voice
                  Technology” and Inbound call solutions. The Company operates
                  various websites and other services including but not limited
                  to delivery of information and content via any mobile or
                  internet connected device or otherwise (collectively the{" "}
                  <strong>“ Services</strong>”).
                </li>

                <li className="mb-5">
                  These terms and conditions (<strong>“Terms of Use”</strong>)
                  apply to your use of this Website. By accessing or otherwise
                  using the site You agree to be bound by these Terms of Use.
                  Any membership accounts You may create by registration on this
                  Website and/or purchase or avail any product or service
                  available through this Website are governed by these Terms of
                  Use. We reserve the sole discretion of updating these Terms of
                  Use from time to time without prior notice. Your continued use
                  of the Website post any update to these Terms of Use would
                  mean acceptance on your part to the amendments made herein.
                </li>
              </ul>
            </li>

            <li className={`${classes.listHeader}`}>
              User Registration
              <ul
                className={`mt-2 ${classes.descList}`}
                style={{ listStyleType: "none" }}
              >
                <li className="mb-5">
                  A “Customer” is anyone who purchases Knowlarity products or
                  services. When a Customer purchases retail products or
                  services for use by others, those individuals also may be
                  considered Customers for purposes of this Policy. User A
                  “User” is anyone who visits our websites. Personal
                  Information. Users who are competent to contract under the
                  Indian Contract Act, 1872, are eligible to register themselves
                  as members on this Website and can avail our Services. Persons
                  who are competent to contract would mean and include every
                  person who, (i) has completed 18 years of age (as per The
                  Indian Majority Act, 1875); (ii) is of sound mind; and (iii)
                  not disqualified from contracting by any law for the time
                  being in force in India.
                </li>

                <li className="mb-5">
                  You would be required to sign up on the Website by providing
                  certain personal details such as name, e-mail address,
                  telephone number, relationship status and mailing address. You
                  agree to provide true, accurate, current and complete
                  information about yourself as prompted by the registration
                  form. If you provide information that is untrue, inaccurate,
                  not current or incomplete, or We have reasonable grounds to
                  suspect that you have provided such information, then the
                  Website may (in addition to any other rights or remedies
                  available to us) refuse registration, suspend access to all
                  current or future use of the Website and the services (or any
                  portion thereof) permanently.
                </li>

                <li className="mb-5">
                  When you sign up on this Website, your personal information
                  will be registered automatically in our database which will be
                  maintained and used by the Website in accordance with the
                  Privacy Policy.
                </li>

                <li className="mb-5">
                  For registration purposes, the User shall submit
                  identification documents as proof of their personal as well as
                  business identity, as regulated by the Department of
                  Telecommunications, Govt. of India. The documents MUST be
                  submitted for approval within 7 days of activation of
                  services. Failure to provide these documents within the
                  stipulated timeline will lead to suspension of services to the
                  account. In case the documents are still not submitted within
                  30 days from the date of suspension, the account will be
                  terminated and the display number will be released back to Our
                  telecom partner. In such an event, We will not be liable to
                  offer any refund, either in full or in part, to the User.
                </li>

                <li className="mb-5">
                  Substantial Delay in Activation of Services We endeavor to
                  activate a user-account in no later than 7 working days of
                  receiving the payment.
                </li>

                <li className="mb-5">
                  The following set of limitations is applicable in achieving
                  these timelines: The timeline can get delayed based on the
                  delay from the User’s end in providing the requisite documents
                  mandatory for the activation of services. These may include,
                  but are not limited to User agreements, ECS agreement form
                  etc.
                </li>

                <li className="mb-5">
                  The timeline can also get delayed based on the changes made by
                  the customer after the initial script and other setting
                  requirements have changed. For script recording in regional or
                  international languages/accents, the timelines can get delayed
                  by 7-10 working days.
                </li>

                <li className="mb-5">
                  National holidays and non-working days are not considered in
                  the timeline to activate services.
                </li>
              </ul>
            </li>

            <li className={`${classes.listHeader}`}>
              Termination
              <ul
                className={`mt-2 ${classes.descList}`}
                style={{ listStyleType: "none" }}
              >
                <li className="mb-5">
                  You may deactivate your membership account at any time and We
                  reserve all rights to deny access, and to suspend or terminate
                  your access to the Website without providing prior notice, for
                  any reason, including violation of any of these Terms of Use
                  by You. In case of termination/ abeyance /suspension of the
                  User’s account/ services due to non-payment or non-renewal of
                  services, or depletion of coins from the User’s accounts, then
                  We will not be held liable for the same and Our obligations
                  will not extend to those instances.
                </li>
              </ul>
            </li>

            <li className={`${classes.listHeader}`}>
              Plans
              <ul
                className={`mt-2 ${classes.descList}`}
                style={{ listStyleType: "none" }}
              >
                <li className="mb-5">
                  Pre-Paid Plans: The User has the option to renew Services at
                  any period after the expiry of the initial term period, but
                  not exceeding a period after two-months as follows:
                </li>

                <li className="mb-5">
                  During the period after expiry of the term for one month the
                  User shall have the option to renew the complete Services with
                  the previous number and the service plan, provided the display
                  number is still available with Us
                </li>

                <li className="mb-5">
                  During the period after expiry of the term and beyond
                  one-month mark before the expiry of two-months the User shall
                  have the option to renew services to the prior number –
                  without a guarantee of the previous service plan. The previous
                  service plan will be reinstated if available – but we do not
                  guarantee the availability of the same number or plan.
                </li>

                <li className="mb-5">
                  Postpaid Plan: This plan shall commence and remain in force
                  from till either the User or We terminate this plan for any
                  reason; or, for no reason by giving 30 days prior written
                  notice to the other party.
                </li>

                <li className="mb-5">
                  The termination of this plan shall be without prejudice to any
                  action or remedy of the User or Us arising prior to the date
                  of termination.
                </li>
              </ul>
            </li>

            <li className={`${classes.listHeader}`}>
              Privacy Guidelines
              <ul
                className={`mt-2 ${classes.descList}`}
                style={{ listStyleType: "none" }}
              >
                <li className="mb-5">
                  For the purposes of User registration, You will be required to
                  choose a password and You shall provide accurate information
                  while creating your account on Our Website. You are
                  responsible for maintaining the confidentiality of your
                  password. We reserve all rights to access, share, communicate,
                  convey, and disseminate some or all of the customer specific
                  information to the extent it is permissible under the
                  applicable laws in India, in order to provide better Services
                  to the Users. We store and protect your personal information
                  including sensitive financial information, if collected, by
                  employing adequate and reasonable security measures in
                  accordance with Information Technology Act, 2000 and the Rules
                  thereunder.
                </li>
              </ul>
            </li>

            <li className={`${classes.listHeader}`}>
              Use of Content
              <ul
                className={`mt-2 ${classes.descList}`}
                style={{ listStyleType: "none" }}
              >
                <li className="mb-5">
                  A variety of information, text, graphics, data and other
                  materials (<strong>“Content”</strong>) is available on the
                  Website. The Content available on the Website shall be used
                  solely for your non-commercial use and/or to benefit from the
                  products, services intimated on the Website. No right, title
                  or interest in any Content is transferred to you, whether as a
                  result of downloading or reproducing such Content or
                  otherwise. The Website reserves complete ownership, title and
                  full intellectual property rights in all Content uploaded by
                  Us. Except as expressly authorized by this Terms of Use, you
                  may not use, alter, copy, distribute, transmit, or derive
                  another work from any Content obtained from the Website or the
                  service. Complete ownership, title and full intellectual
                  property rights in all works/content uploaded by any user on
                  the website belongs to such User.
                </li>

                <li className="mb-5">
                  The Website grants you a nonexclusive, non-transferable,
                  revocable, limited license to view the Content retrieved from
                  the Website only for your personal, noncommercial use,
                  provided that you do not remove or obscure any copyright
                  notice, trademark notice, or other proprietary rights notices
                  displayed on or in conjunction with the Content. You may not
                  use any Content available via the Website in any other manner
                  or for any purpose without the prior written permission of the
                  Website. All rights not expressly granted in this Terms of
                  Service are expressly reserved to Us.
                </li>

                <li className="mb-5">
                  The Website may at any time modify, discontinue, or suspend
                  its operation of this Website, or any part thereof,
                  temporarily or permanently, without notice to you.
                </li>
              </ul>
            </li>

            <li className={`${classes.listHeader}`}>
              Scope of Work
              <ul
                className={`mt-2 ${classes.descList}`}
                style={{ listStyleType: "none" }}
              >
                <li className="mb-5">
                  The scope of work includes providing cloud communication
                  services for the User’s business requirements including
                  Inbound & Outbound call solution system for providing support
                  services and IT solutions related to cloud communication
                  products including but not limited to “SuperReceptionist”,
                  “SmartIVR”, and “Automated Voice Technology”.
                </li>
              </ul>
            </li>

            <li className={`${classes.listHeader}`}>
              Payment for Services
              <ul
                className={`mt-2 ${classes.descList}`}
                style={{ listStyleType: "none" }}
              >
                <li className="mb-5">
                  You agree to employ any of the electronic or other modes of
                  payment available against the fee you make to our Website
                  (i.e., net banking, debit cards, credit cards, prepaid wallet,
                  other electronic means). You understand and acknowledge that
                  We are expressly authorized to collect, process, facilitate
                  and remit this fee made electronically by You.
                </li>

                <li className="mb-5">
                  For Post-Paid plans, usage charges will be billed on the basis
                  of the actual usage at the end of every month, which should be
                  clear within 15 days from the date of receipt of Invoice.
                </li>

                <li className="mb-5">
                  For Pre-Paid plans, usage charges will be ongoing and deducted
                  from the credits purchased at the commencement of the plan.
                </li>

                <li className="mb-5">
                  The invoice(s) submitted by Us shall be subject to inspection
                  and verification by the User and any discrepancies therein
                  shall be brought to Our notice within 7 days of receipt of the
                  invoice(s). If necessary, We shall modify and provide an
                  amended invoice(s) and User will make the payments as per the
                  modified invoice(s).
                </li>

                <li className="mb-5">
                  Taxes will be additional as applicable.
                </li>
              </ul>
            </li>

            <li className={`${classes.listHeader}`}>
              Resolution and Escalation Matrix
              <ul
                className={`mt-2 ${classes.descList}`}
                style={{ listStyleType: "none" }}
              >
                <li className="mb-5">
                  We will strive to resolve any delay in Services delivery. User
                  can write to Us at <em>customersupport@knowlarity.com</em> for
                  any query or concern. We will address this concern within 48
                  hours. To ensure timely resolution when User escalates its
                  concern, User must mention the ticket number received from
                  <em> customersupport@knowlarity.com</em> ; and, a brief
                  summary on why the resolution provided so far has not been
                  satisfactory. Certain issues, depending on their nature, would
                  require testing and observation over multiple days. This can
                  increase the resolution time for the User. However, We assure
                  that Our team will be working on these issues diligently
                  throughout and will keep the User updated on the progress. For
                  raising ticket please click the below link:-
                  https://support.knowlarity.com/portal/newticket In case We are
                  unable to resolve the issue within the stated timeline, or if
                  the User is not satisfied with the resolution provided, User
                  can escalate its concern to Our management at
                  <em> grievances@knowlarity.com</em>. We will address the
                  User’s concern within 24 working hours. If User is still not
                  satisfied with the resolution provided by Our management, User
                  can write directly to Our leadership team at at
                  <em> ceo@knowlarity.com</em>. Any concerns raised here will be
                  addressed in two working hours and will require further 48
                  working hours for a resolution. National holidays and
                  non-working days are not considered in the timeline.
                </li>
              </ul>
            </li>

            <li className={`${classes.listHeader}`}>
              Exit Policy and Transfer of Ownership of the Display Number
              <ul
                className={`mt-2 ${classes.descList}`}
                style={{ listStyleType: "none" }}
              >
                <li className="mb-5">
                  In case the contract between Us and the User has expired and
                  the User decides not to renew the contract or extend services,
                  We can, upon request, transfer the ownership of the display
                  number to the User. The following conditions will dictate this
                  policy:
                  <ol type="i" className="mt-5">
                    <li className="mb-5">
                      Only virtual mobile numbers shall be transferable.
                    </li>

                    <li className="mb-5">
                      The ownership of Landline/PSTN/Toll-Free numbers is not
                      transferable.
                    </li>

                    <li className="mb-5">
                      We will charge a nominal fee of INR 1000 to assist with
                      the transfer of ownership.
                    </li>

                    <li className="mb-5">
                      In case the User decides to initiate the process on
                      his/her own, We will terminate & release the number from
                      Our end and the User will have to contact the telecom
                      operator directly to obtain the ownership of the number.
                      In this case, the User does not have to pay any fees to Us
                      for transfer of ownership.
                    </li>

                    <li className="mb-5">
                      The User can choose to keep the services activated until
                      the number porting process is complete. In this case, User
                      will be charged the rental and usage charges on a pro-rata
                      basis.
                    </li>
                  </ol>
                </li>
              </ul>
            </li>

            <li className={`${classes.listHeader}`}>
              Unavailability of Desired or Committed Display Number
              <ul
                className={`mt-2 ${classes.descList}`}
                style={{ listStyleType: "none" }}
              >
                <li className="mb-5">
                  We will try to amicably resolve such issue by proposing best
                  alternatives as a replacement to the desired number. No refund
                  will be entertained if We do not find genuine interest on part
                  of the User to resolve the issue, however if the issue is not
                  resolved within 30 days from the date of payment, the User is
                  entitled to 75% of amount paid, in addition to any charges
                  paid towards obtaining a vanity display number.
                </li>
              </ul>
            </li>

            <li className={`${classes.listHeader}`}>
              Refund Policy
              <ul
                className={`mt-2 ${classes.descList}`}
                style={{ listStyleType: "none" }}
              >
                <li className="mb-5">
                  In case, where We have failed to provide the services as per
                  the agreement, we shall be liable to refund for the said
                  services. We will only be liable to refund the part of
                  services unused by the client. Refund is subject to
                  justifiable reasons for the said unused services. In the
                  absence of plausible cause, no refund claims will be
                  entertained once service acceptance is received from the user.
                  Also, We will not be liable to refund the User in cases of
                  force majeure or outages where We do not have a control over
                  the resolution time, for eg. Outages at the end of our Telecom
                  Partners, Cloud Partners, Internet Services Providers or
                  Internet Hackers.
                </li>
              </ul>
            </li>

            <li className={`${classes.listHeader}`}>
              Intellectual Property Rights
              <ul
                className={`mt-2 ${classes.descList}`}
                style={{ listStyleType: "none" }}
              >
                <li className="mb-5">
                  This Website is owned by Knowlarity Communications Private
                  Limited. All rights to, title and interest in the Content
                  available on/ via the Website, the Website’s look and feel,
                  the designs, trademarks, service marks, and trade names
                  displayed on the Website, and the Website URLs, are the
                  property of Knowlarity Communications Private Limited or its
                  licensors, and are protected by copyrights, trademarks,
                  patents, or other proprietary rights and laws.
                </li>
                <li className="mb-5">
                  The Website and the Content are protected by copyright laws,
                  and belong to Us or its partners, affiliates or contributors.
                  The copyrights in the Content are owned by Us or other
                  copyright owners who have authorized their use on the Website.
                  You may not manipulate or alter the images or other Content on
                  the Website in any way.
                </li>
              </ul>
            </li>

            <li className={`${classes.listHeader}`}>
              Prohibited Use of the Website
              <ul
                className={`mt-2 ${classes.descList}`}
                style={{ listStyleType: "none" }}
              >
                <li className="mb-5">
                  In accessing any part of our Website, you agree:
                </li>
                <li className="mb-5">
                  not to use our Website in such a way that disrupts, interferes
                  with or restricts the use of our site by other Users;
                </li>

                <li className="mb-5">
                  not to reverse engineer, de-compile, copy or adapt any
                  software or other code or scripts forming part of our Website;
                  and
                </li>

                <li className="mb-5">
                  not to change, modify, delete, interfere with or misuse data
                  contained on our site and entered by or relating to any third
                  party user of our Website.
                </li>
                <li className="mb-5">
                  material contained in our site must not be reproduced or
                  exploited for commercial gain. All other rights are reserved
                  and users must seek our permission before making any other use
                  of material contained in our Website.
                </li>

                <li className="mb-5">
                  not to use the Website and its solutions for purposes that are
                  unlawful or prohibited under law. The User acknowledges that
                  the IT Solutions include the use of telephonic resources and
                  thereby are required to use them in compliance with applicable
                  laws and regulations of the Telecom Regulatory Authority of
                  India and the Department of Telecommunication.
                </li>

                <li className="mb-5">
                  not to use the Website in any manner that may damage, disable,
                  overburden, or impair the services of Knowlarity, telephonic
                  numbers and servers, or the network(s) connected to any User
                  server
                </li>
              </ul>
            </li>

            <li className={`${classes.listHeader}`}>
              Communication
              <ul
                className={`mt-2 ${classes.descList}`}
                style={{ listStyleType: "none" }}
              >
                <li className="mb-5">
                  You consent to receive communications from us by way of
                  emails, phone calls and SMS’s with respect to your
                  transactions on our Website. Users will be required to
                  register their valid phone numbers and e-mail addresses to
                  facilitate such communication. We may also use your e-mail
                  address to send You updates, newsletters, changes to features
                  of the Service, and the like to provide You better Services.
                </li>
              </ul>
            </li>

            <li className={`${classes.listHeader}`}>
              Disclaimer of Warranties and Liability
              <ul
                className={`mt-2 ${classes.descList}`}
                style={{ listStyleType: "none" }}
              >
                <li className="mb-5"></li>
                You understand and acknowledge that You are availing our
                Services and transacting on our Website at your own risk. We
                shall neither be liable nor responsible for any actions or
                inactions of the User. We further expressly disclaim any
                warranties, conditions, representation and stipulations (express
                or implied) in respect of quality, reliability, accuracy,
                timeliness, performance, safety, merchantability, fitness for a
                particular purpose, or legality of the products displayed or
                transacted on our Website.
              </ul>
            </li>

            <li className={`${classes.listHeader}`}>
              Indemnity
              <ul
                className={`mt-2 ${classes.descList}`}
                style={{ listStyleType: "none" }}
              >
                <li className="mb-5">
                  You agree to indemnify, defend and hold harmless Knowlarity
                  Communications Private Limited and its affiliates, agents,
                  employees, directors, officers, agents, vendors and suppliers
                  from and against any liability, losses, claims, damages,
                  demands, investigations, inquiries, suits, costs and expenses
                  (including legal fee and costs incidental thereto) asserted
                  against or incurred by Knowlarity Communications Private
                  Limited that arise out of or otherwise relating to your use of
                  the Website, including without limitation any obligation to be
                  performed by You pursuant to these Terms of Use. Further, you
                  agree to hold Knowlarity Communications Private Limited
                  harmless against any claims made by any third party due to, or
                  arising out of or otherwise relating to your use of the
                  Website, any claim arising out of damage caused to third party
                  by You, breach of these Terms of Use by You, or your violation
                  of any rights of another, including any intellectual property
                  rights.
                </li>

                <li className="mb-5">
                  Notwithstanding anything to the contrary, Ourentire liability
                  towards You under these Terms of Use or otherwise shall only
                  be in connection with refund of the money charged from You for
                  any particular product or service, under which the unlikely
                  liability arises.
                </li>
              </ul>
            </li>

            <li className={`${classes.listHeader}`}>
              Limitation of Liability
              <ul
                className={`mt-2 ${classes.descList}`}
                style={{ listStyleType: "none" }}
              >
                <li className="mb-5">
                  The Website and its affiliates assume no responsibility for
                  any consequence relating directly or indirectly to any action
                  or inaction taken based on the Content available on the
                  Website. You must evaluate, and bear all risks associated
                  with, the use of any Content, including any reliance on the
                  accuracy, completeness, or usefulness of such Content. You
                  specifically acknowledge that the Website and its affiliates
                  are not liable for any defamatory, offensive or illegal
                  conduct by the User or any third party. Additionally, in no
                  event the Website will or its affiliates be liable for any
                  special, indirect, incidental, punitive, or consequential
                  damages, including, without limitation, any loss of use, loss
                  of profits, loss of data, cost of procurement of substitute
                  products or services, or any other such damages, howsoever
                  caused, and on any theory of liability, whether for breach of
                  contract, tort (including negligence and strict liability), or
                  otherwise resulting from the use of, or the inability to use
                  the Website or its Content; the cost of procurement of
                  substitute services, provided by the Website; unauthorized
                  access to or alteration of your transmissions or data; the
                  statement or conduct of any third party on the Website; or any
                  other matter relating to the Website. These limitations will
                  apply whether or not the Website has been advised of the
                  possibility of such damages and notwithstanding any failure of
                  essential purpose of any limited remedy.
                </li>
              </ul>
            </li>

            <li className={`${classes.listHeader}`}>
              Plans
              <ul
                className={`mt-2 ${classes.descList}`}
                style={{ listStyleType: "none" }}
              >
                <li className="mb-5">
                  The Website expressly disclaims all warranties of any kind,
                  whether express or implied, including, without limitation, any
                  warranties in relation to materials posted on the Website and
                  are not intended to amount to advice on which reliance should
                  be placed without verification by the user. The Website
                  disclaims all liability and responsibility arising from any
                  reliance placed on such materials on the Website, or by anyone
                  who may be informed of any of its contents.
                </li>

                <li className="mb-5">
                  No warranties are made that the Website will meet your
                  requirements, or that access to the Website will be
                  uninterrupted, timely, secure, or error-free, or that defects,
                  if any, will be corrected. The Website makes no warranties as
                  to the accuracy, or reliability of any information provided
                  through the Website.
                </li>
              </ul>
            </li>

            <li className={`${classes.listHeader}`}>
              Waiver
              <ul
                className={`mt-2 ${classes.descList}`}
                style={{ listStyleType: "none" }}
              >
                <li className="mb-5">
                  Any failure on our part to exercise any provision or right
                  under these Terms of Use, shall not constitute a waiver by Us
                  of that provision or right
                </li>
              </ul>
            </li>

            <li className={`${classes.listHeader}`}>
              Governing Law and Dispute Resolution
              <ul
                className={`mt-2 ${classes.descList}`}
                style={{ listStyleType: "none" }}
              >
                <li className="mb-5">
                  The present Terms of Use shall be governed and construed in
                  accordance with the laws of India, without regard to its
                  conflict of law provisions. All disputes shall be decided by
                  single arbitrator mutually appointed by both parties. In case
                  the parties cannot mutually nominate an arbitrator, the
                  arbitrator’s appointment shall be governed in accordance with
                  the Arbitration and Conciliation Act 1996 or any statutory
                  enactment thereof. Any arbitration shall be confidential, and
                  neither You nor We may disclose the existence, content or
                  results of any arbitration, except as may be required by law
                  or for purposes of the arbitration award; the award of which
                  is binding on both parties. All administrative fees and
                  expenses of arbitration will be divided equally between You
                  and Us. In all arbitrations, each party will bear the expense
                  of its own lawyers and preparation. The seat of arbitration
                  shall be New Delhi and all proceedings shall be conducted in
                  English.
                </li>
              </ul>
            </li>

            <li className={`${classes.listHeader}`}>
              Contact Information
              <ul
                className={`mt-2 ${classes.descList}`}
                style={{ listStyleType: "none" }}
              >
                <li className="mb-5">
                  If you have any questions or concerns with respect to this
                  Terms of Use or the Website or any information contained on
                  thereon, you may contact us by writing to us at
                  customersupport@knowlarity.com
                </li>
              </ul>
            </li>
          </ol>
        </div>
      </SoundsDialog>
    </div>
  );
};

export default SoundsDisclaimer;
